function viewportDimensions() {
    return {
        w: window.innerWidth || document.documentElement.clientWidth,
        h: window.innerHeight || document.documentElement.clientHeight,
    };
}
export function centerOfScreen(elementRect) {
    const viewport = viewportDimensions();
    const centerX = viewport.w / 2;
    const centerY = viewport.h / 2;
    return {
        x: centerX - elementRect.width / 2,
        y: centerY - elementRect.height / 2,
        w: elementRect.width,
        h: elementRect.height,
    };
}
